<script lang="ts">
	import type { PageProps } from "./$types";
	import { TermsAndConditions } from "#lib/web-ui/blocks/index.js";

	let { data }: PageProps = $props();
	const { contactInfo } = data;
</script>

<svelte:head>
	<title>Terms & Conditions | Fergmar Capital</title>
	<meta
		name="description"
		content="Review the Terms & Conditions for using Fergmar Capital's services, website, and SMS communications."
	/>
	<meta name="viewport" content="width=device-width, initial-scale=1.0" />
	<meta property="og:title" content="Terms & Conditions | Fergmar Capital" />
	<meta property="og:site_name" content="Fergmar Capital" />
	<meta
		property="og:description"
		content="Review the Terms & Conditions for using Fergmar Capital's services, website, and SMS communications."
	/>
</svelte:head>

<TermsAndConditions
	entityName="Fergmar Capital, LLC"
	email={contactInfo.email}
	phone={contactInfo.phone}
	address={contactInfo.address}
	lastUpdated="May 12th, 2026"
/>
